import { Toaster } from "@/components/ui/sonner";
import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
  Route,
  redirect,
} from "react-router-dom";
import { RootLayout } from "./components/AuthQueryCacheSync";
import Layout, { protectedLoader } from "./components/Layout";
import { OraculLoader } from "./components/OraculLoader";
import Login, { loginAction, loginLoader } from "./pages/Login";
import Dashboard, { dashboardLoader } from "./pages/Dashboard";
import Analytics, { analyticsLoader } from "./pages/Analytics";
import Clicks, { clicksLoader } from "./pages/Clicks";
import Indexation from "./pages/Indexation";
import ImportPage, { importDomainsAction } from "./pages/ImportPage";
import KeywordVolume, { keywordVolumeLoader } from "./pages/KeywordVolume";
import SpyImport from "./pages/SpyImport";
import SpyDashboard from "./pages/SpyDashboard";
import Settings, { settingsLoader } from "./pages/Settings";
import Account, { accountLoader } from "./pages/Account";
import Reports, { reportsLoader } from "./pages/Reports";
import GscLayout from "./components/gsc/GscLayout";
import GscOverview, { gscOverviewLoader } from "./pages/GscOverview";
import GscDetail, { gscDetailLoader } from "./pages/GscDetail";
import GscCompare, { gscCompareLoader } from "./pages/GscCompare";
import ErrorPage from "./pages/ErrorPage";
import "./App.css";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />} errorElement={<ErrorPage />}>
      <Route
        path="/login"
        element={<Login />}
        action={loginAction}
        loader={loginLoader}
        errorElement={<ErrorPage />}
        HydrateFallback={OraculLoader}
      />
      <Route
        path="/"
        id="layout"
        element={<Layout />}
        loader={protectedLoader}
        errorElement={<ErrorPage />}
        HydrateFallback={OraculLoader}
      >
        <Route index element={<Dashboard />} loader={dashboardLoader} />
        <Route
          path="analytics"
          element={<Analytics />}
          loader={analyticsLoader}
        />
        <Route path="clicks" element={<Clicks />} loader={clicksLoader} />
        {/* Indexation is the unified page (DMCA merged in as columns). Old /dmca
            links redirect so bookmarks keep working. */}
        <Route path="indexation" element={<Indexation />} />
        <Route path="dmca" loader={() => redirect("/indexation")} />
        <Route path="gsc" element={<GscLayout />}>
          <Route index element={<GscOverview />} loader={gscOverviewLoader} />
          <Route
            path="detail"
            element={<GscDetail />}
            loader={gscDetailLoader}
          />
          <Route
            path="compare"
            element={<GscCompare />}
            loader={gscCompareLoader}
          />
        </Route>
        <Route
          path="import"
          element={<ImportPage />}
          action={importDomainsAction}
        />
        <Route
          path="keyword-volume"
          element={<KeywordVolume />}
          loader={keywordVolumeLoader}
        />
        <Route path="spy-dashboard" element={<SpyDashboard />} />
        <Route path="spy-import" element={<SpyImport />} />
        {/* Team Members moved into Settings → Team Members tab. Old /users links
            redirect so bookmarks keep working. */}
        <Route path="users" loader={() => redirect("/settings")} />
        <Route
          path="settings"
          element={<Settings />}
          loader={settingsLoader}
        />
        <Route path="account" element={<Account />} loader={accountLoader} />

        <Route path="reports" element={<Reports />} loader={reportsLoader} />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Route>,
  ),
);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
}

export default App;
